<div *ngIf="billingCodeOrg" class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.mykeys" class="cp-user-nav-item me-1" size="sm">
				</fa-icon>
				<a href="javascript:void(0)" [routerLink]="['/' + ac.urls.mykeys]">My Keys</a>
			</li>
			<li class="breadcrumb-item" aria-current="page">
				{{ billingCodeOrg.org.name }}
			</li>
			<li class="breadcrumb-item active" aria-current="page">
				New Billing Code(s)
			</li>
		</ol>
	</nav>
</div>

<form *ngIf="theForm" [formGroup]="theForm">
	<div class="cp-general-width-limit">
		<div *ngIf="loading || saving" style="text-align: center;">
			<app-loading-spinner></app-loading-spinner>
		</div>

		<div class="form-group">
			<label for="labels">Billing Code Name(s)/Label(s)*</label>
			<textarea id="labels" formControlName="labels" class="form-control" rows="8"></textarea>
		</div>

		<div class="form-group">
			Enter label(s) in the box above. One per line.
		</div>
	</div>

	<div class="cp-form-padding"></div>

	<div *ngIf="!loading && theForm" class="cp-form-buttons">
		<div class="cp-form-buttons-inner">
			<button class="btn btn-primary me-1" type="button" (click)="onSubmit()" [disabled]="!theForm.valid || saving">
				<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
			</button>
			<button class="btn btn-outline-secondary" type="button" (click)="onCancel()" [disabled]="saving">
				<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
			</button>

			<span class="gj-75 ps-2">* Required</span>
		</div>
	</div>

</form>